export const captchaKeys = {
	USERS_CAPTCHA_KEY: '6LeMTvYZAAAAAD5cO5uuUw9CvAWqxZRrze6MTSUs'
}
